import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-sketch.tsx
/**
* icon.24.sketch
*
* Keywords: diamond, gem, jewel, faceted, luxury, precious, value, wealth
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOC42IDcuMkEuNS41IDAgMCAxIDkgN2gybC0yLjI1IDNINi41ek02LjU1IDExbDQuNDg2IDUuNTIxTDguNjcgMTF6bTYuNDEzIDUuNTIyTDE3LjQ1IDExaC0yLjEyek0xNy41IDEwbC0yLjEtMi44QS41LjUgMCAwIDAgMTUgN2gtMmwyLjI1IDN6TTkgNmExLjUgMS41IDAgMCAwLTEuMi42TDUuNTY4IDkuNTc1YTEuNSAxLjUgMCAwIDAgLjAzNiAxLjg0Nmw1LjIzMiA2LjQ0YTEuNSAxLjUgMCAwIDAgMi4zMjggMGw1LjIzMi02LjQ0YTEuNSAxLjUgMCAwIDAgLjAzNi0xLjg0NkwxNi4yIDYuNkExLjUgMS41IDAgMCAwIDE1IDZ6bS43NTggNUwxMiAxNi4yMyAxNC4yNDIgMTF6TTEwIDEwbDItMi42NjdMMTQgMTB6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-10933
*/
const Icon24Sketch = memo(function Icon24Sketch(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M8.6 7.2A.5.5 0 0 1 9 7h2l-2.25 3H6.5zM6.55 11l4.486 5.521L8.67 11zm6.413 5.522L17.45 11h-2.12zM17.5 10l-2.1-2.8A.5.5 0 0 0 15 7h-2l2.25 3zM9 6a1.5 1.5 0 0 0-1.2.6L5.568 9.575a1.5 1.5 0 0 0 .036 1.846l5.232 6.44a1.5 1.5 0 0 0 2.328 0l5.232-6.44a1.5 1.5 0 0 0 .036-1.846L16.2 6.6A1.5 1.5 0 0 0 15 6zm.758 5L12 16.23 14.242 11zM10 10l2-2.667L14 10z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Sketch };

//# sourceMappingURL=icon-24-sketch.js.map